// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-apply-choice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, #d0d7de));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));
  color: var(--text-color, #1a1a1a);
  font: inherit;
  cursor: pointer;
}

.template-apply-choice strong {
  font-size: 15px;
  font-weight: 750;
}

.template-apply-choice span {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #555);
}

.template-apply-choice--primary {
  color: #fff;
  border: none;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
}

.template-apply-choice--primary span {
  color: rgba(255, 255, 255, 0.88);
}

.template-apply-choice:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.template-apply-level {
  margin-top: 12px;
}

.template-apply-level__hint {
  margin: 0 0 12px;
  color: var(--text-secondary, #555);
}

.template-apply-level__option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
}

.template-apply-level__option strong {
  font-weight: 700;
}

.template-apply-level__option span {
  font-size: 13px;
  color: var(--text-secondary, #555);
}

.template-apply-level__summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
}

.template-apply-level__note {
  font-size: 13px;
  color: var(--text-secondary, #555);
}

.template-apply-level__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.template-apply-level__chip--intro.MuiChip-outlined {
  border-style: dashed;
}

.template-apply-level__blocks {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.template-apply-level__label {
  font-size: 12px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary, #555);
}

.template-apply-level__slot-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/TemplateApplyWizardDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qGAAqG;EACrG,4FAA4F;EAC5F,iCAAiC;EACjC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV","sourcesContent":[".template-apply-choice {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  text-align: left;\n  padding: 14px 16px;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color, #d0d7de));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));\n  color: var(--text-color, #1a1a1a);\n  font: inherit;\n  cursor: pointer;\n}\n\n.template-apply-choice strong {\n  font-size: 15px;\n  font-weight: 750;\n}\n\n.template-apply-choice span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-choice--primary {\n  color: #fff;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n}\n\n.template-apply-choice--primary span {\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.template-apply-choice:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.template-apply-level {\n  margin-top: 12px;\n}\n\n.template-apply-level__hint {\n  margin: 0 0 12px;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-level__option {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 4px 0;\n}\n\n.template-apply-level__option strong {\n  font-weight: 700;\n}\n\n.template-apply-level__option span {\n  font-size: 13px;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-level__summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.template-apply-level__note {\n  font-size: 13px;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-level__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.template-apply-level__chip--intro.MuiChip-outlined {\n  border-style: dashed;\n}\n\n.template-apply-level__blocks {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.template-apply-level__label {\n  font-size: 12px;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-level__slot-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
